<template>
  <b-card class="shadow" style="min-height: 700px" id="printme">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Acessos ao Sistema") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar para Excel')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-12" v-if="viewFilterReport">
        <!-- Filtros -->
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-calendar
              v-model="data_inicio"
              grid="3"
              label="Data inicial"
              :max-date="dataNow"
            />

            <form-calendar
              v-model="data_fim"
              grid="3"
              label="Data final"
              :required="verificaDataInicial"
              :min-date="data_inicio"
              :max-date="dataNow"
            />

            <form-select
              v-model="filtroStatus"
              grid="6"
              label="Status"
              :itens="status"
              :loading="loadingStatus"
              :disabled="loadingStatus"
              multiple
            />

            <form-select
              v-model="filtroUnidades"
              label="Unidade(s)"
              grid="4"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              multiple
              @input="getTecnicos()"
            />

            <form-select
              v-model="filtroTecnicos"
              label="Técnico(s)"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnico"
              :grid="4"
              placeholder="Selecione uma unidade antes"
              multiple
            />

            <form-select
              grid="4"
              v-model="filtroRoles"
              :itens="roles"
              placeholder="Selecione"
              label="Função na Unidade/Sistema"
              :multiple="true"
            />

            <div class="col-md-12">
              <label><b>Pesquisar por nome do técnico</b></label>
              <div class="input-group">
                <b-input
                  placeholder="Pesquisar por nome do técnico"
                  class="form-control search-input"
                  type="text"
                  v-model="search"
                  aria-describedby="input-search"
                  @keydown.enter.prevent="getAnalytics"
                />
              </div>
            </div>
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>

      <div class="col-md-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />

        <print-content>
          <template v-slot:datas>
            <div class="d-flex justify-content-between">
              <p>
                Período de pesquisa selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </b-link>
              </p>

              <p>
                Total de Acessos: <b>{{ totalAcessos }}</b>
              </p>

              <span>
                <b-link
                  variant="default"
                  v-if="agruparPor == 'acessos'"
                  @click="(agruparPor = 'unidades'), getAnalytics()"
                >
                  Agrupar por Unidades
                </b-link>
                <b-link
                  v-else
                  variant="default"
                  @click="(agruparPor = 'acessos'), getAnalytics()"
                >
                  Agrupar por Acessos
                </b-link>
              </span>
            </div>
          </template>

          <b-table
            :fields="[
              {
                key: 'acessos',
                label: $t('Acessos'),
                sortable: true,
              },
              {
                key: 'tecnico',
                label: $t('Técnico'),
              },
              {
                key: 'email',
                label: $t('E-mail/Telefone'),
              },
              {
                key: 'unidade',
                label: $t('Unidade'),
                sortable: true,
              },
              {
                key: 'created_at',
                label: $t('Datas'),
                sortable: true,
              },
            ]"
            :items="listaacessos"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-local-sorting
            @sort-changed="changeSort"
          >
            <template v-slot:cell(acessos)="data">
              <span class="font-weight-bold">{{ data.item.acessos }}</span>
            </template>
            <template v-slot:cell(tecnico)="data">
              <span class="font-weight-bold">
                {{ data.value }}
              </span>
              <small class="text-muted d-block">{{ data.item.funcao }}</small>
              <small
                class="text-muted d-block text-success"
                v-if="data.item.status == 'ATIVO'"
              >
                <b>{{ data.item.status }}</b>
              </small>
              <small
                class="text-muted d-block text-danger"
                v-else-if="data.item.status == 'INATIVO'"
              >
                <b>{{ data.item.status }}</b>
              </small>
            </template>
            <template v-slot:cell(email)="data">
              {{ data.value }}
              <small class="text-muted d-block" v-if="data.item.whatsapp">
                <b>
                  <i class="fab fa-whatsapp"></i>
                  {{ data.item.whatsapp }}
                </b>
              </small>
              <small class="text-muted d-block" v-if="data.item.telefone">
                <i class="fas fa-phone-alt"></i>
                {{ data.item.telefone }}
              </small>
            </template>
            <template v-slot:cell(unidade)="data">
              {{ data.value }}
            </template>
            <template v-slot:cell(created_at)="data">
              <small>
                Criado em: {{ data.item.cadastrado | formatDate }}<br />
                Atualizado em:
                {{ data.item.atualizado | formatDateHora }}
              </small>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </print-content>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getAnalytics"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }} {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
        <div class="row no-print mt-4">
          <div class="col-lg-12 col-md-12 text-center align-items-center">
            <b-button
              :title="$t('Visualizar e Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeReportDenuncias",
  data() {
    return {
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnico: true,
      loadingStatus: false,
      itensList: [],
      unidades: [],
      page: 1,
      search: "",
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtros: {
        unidade: null,
      },
      isLoadingMsg: false,
      filter: false,
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,
      loadingStatus: false,
      tecnicos: [],
      status: [],
      datas: [],
      dataNow: moment().format("YYYY/MM/DD"),
      filtroDatas: [],
      filtroStatus: [],
      filtroUnidades: [],
      filtroTecnicos: [],
      filtroRoles: [],
      agruparPor: "acessos",
      sortBy: "acessos",
      sortDesc: true,
      order: "desc",
      totalAcessos: 0,
      roles: [],
      idades: null,
    };
  },
  created() {
    this.min = 0;
    this.max = 130;
    this.enableCross = false;
  },
  watch: {
    showfiltroIdade(val) {
      this.filtroIdade = val ? [0, 130] : [];
    },
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
    listaacessos() {
      const users = this.itensList;

      const map = users.map((elem) => ({
        acessos: elem.acessos_count,
        tecnico: elem.name,
        status: elem.get_status ? elem.get_status.descricao : "",
        funcao: elem.role.name,
        email: elem.email,
        telefone: elem.tecnico ? elem.tecnico.telefone : "",
        whatsapp: elem.tecnico ? elem.tecnico.whatsapp : "",
        unidade: elem.tecnico ? elem.tecnico.unidade.nome : "",
        cadastrado: elem.created_at,
        atualizado: elem.updated_at,
      }));
      return map;
    },
  },
  mounted() {
    this.getAnalytics();
    this.getStatus();
    this.getUnidades();
    this.getRoles();
  },
  methods: {
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAnalytics();
      }
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.order = ctx.sortDesc === true ? "desc" : "asc";
      this.getAnalytics();
    },
    async getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      if (this.filtroIdade && this.filtroIdade.length > 0) {
        this.idades =
          "Usuários com Idade entre: " +
          this.filtroIdade[0] +
          " ano(s) e " +
          this.filtroIdade[1] +
          " ano(s)";
      }

      await axios
        .get("api/dashboard/report/acessos/home", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroRoles: this.filtroRoles,
            sort: {
              column: this.sortBy,
              order: this.order,
            },
            agruparPor: this.agruparPor,
          },
        })
        .then((response) => {
          this.loading = false;

          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.unidade;
          this.role = this.$store.state.user.role;

          this.datas = response.data.datas;
          this.itensList = response.data.dados.data;
          this.totalAcessos = response.data.totalAcessos;

          this.pagination.currentPage = response.data.dados.current_page;
          this.pagination.perPage = response.data.dados.per_page;
          this.pagination.total = response.data.dados.total;
          this.pagination.totalPages = response.data.dados.last_page;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAnalytics();
          } else {
            this.isLoadingMsg = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
    },

    exportar() {
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/acessos/home", {
          params: {
            exportarExcel: "ok",
            range: this.range,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroDatas: this.filtroDatas,
            filtroStatus: this.filtroStatus,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroRoles: this.filtroRoles,
            sort: {
              column: this.sortBy,
              order: this.order,
            },
            agruparPor: this.agruparPor,
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.loading = false));
    },

    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/acessos/status/tecnicos`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnico = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnico = false));
    },
    async getRoles() {
      // Get all settings values
      await axios
        .get("api/dashboard/report/acessos/users/roles")
        .then((response) => {
          if (response.data.data) {
            this.roles = response.data.data.map((elem) => ({
              id: elem.id,
              value: elem.name,
            }));
          }

          // this.roles = response.data.data;
          this.loading = false;
        });
    },
    limparFiltros() {
      //   this.filtros = {};
      this.search = "";
      this.data_inicio = null;
      this.data_fim = null;
      this.filtros.data_inicial = null;
      this.filtros.data_final = null;

      this.filtroDatas = [];
      this.filtroStatus = [];
      this.filtroUnidades = [];
      this.filtroUnidadesEncaminhada = [];
      this.filtroCanal = [];
      this.filtroDenunciante = [];
      this.filtroTecnicos = [];
      this.filtroIdade = [];
      this.showfiltroIdade = false;
      this.idades = null;
      this.getAnalytics();
    },
  },
};
</script>
